export default "__VITE_ASSET__7911657d__"